var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"toolbar"},[_vm._t("start"),_vm._v(" "),_c('div',{staticClass:"primary-content"},[_vm._t("default")],2),_vm._v(" "),_vm._t("end")],2)}
var staticRenderFns = []

export { render, staticRenderFns }